module.exports = __webpack_public_path__ + "static/media/ArchivedFolderWithFiles.e9067f39.svg";